import { render, staticRenderFns } from "./IndumentariasCard.vue?vue&type=template&id=b6697458"
import script from "./IndumentariasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IndumentariasCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports